import { render, staticRenderFns } from "./VideoItems5Template.vue?vue&type=template&id=3c6c40ea"
import script from "./VideoItems5Template.vue?vue&type=script&lang=js"
export * from "./VideoItems5Template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports